<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="名称">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="跳转类型">
                <a-select
                  show-search
                  v-model="queryParam.jumpType"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="item.id" v-for="item  in options" >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select
                  show-search
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="item.id" v-for="item  in optionStatus" >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="布局">
                <a-select
                  show-search
                  v-model="queryParam.type"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="item.id" v-for="item  in optionType" >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="搜索次数	">
                <a-input v-model="queryParam.searchCount" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['upkeep:layout:add']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['upkeep:layout:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button
            type="danger"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['upkeep:layout:remove']"
          >
            <a-icon type="delete" />删除
          </a-button>
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
        :options="options"
        :optionStatus="optionStatus"
        :optionType="optionType"

      />
      <!-- 批量导入 -->
      <!-- <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd> -->

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="jumpType" slot-scope="text, record">
          {{ record.jumpType==0?'商品':record.jumpType==1?'服务分类':record.jumpType==2?'预约施压单':record.jumpType==2?'优惠卷':'人工客服' }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type==0?'上部':'中部' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['upkeep:layout:edit']"
          >
            修改
          </a>
          <a-divider type="vertical" v-hasPermi="['upkeep:layout:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['upkeep:layout:remove']"> 删除 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/repairModule/homepage'
import CreateForm from './modules/CreateForm'

import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
// import UploadAdd from './modules/uploadAdd'
// import Parameter from '../../pressure/parameter'
import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { mapGetters } from 'vuex'
import { options } from 'less'
export default {
  name: 'Post',
  components: {
    CreateForm,
    UploadAdd,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      options: [
        { name: '商品', id: 0 },
        { name: '服务分类', id: 1 },
        { name: '预约施压单', id: 2 },
        { name: '优惠卷', id: 3 },
        { name: '人工客服', id: 4 },
      ],
      optionStatus: [
        { name: '禁用', id: 0 },
        { name: '启用', id: 1 },
      ],
      optionType: [
        { name: '上部', id: 0 },
        { name: '中部', id: 1 },
      ],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
      },
      columns: [
        {
          title: '名称',
          dataIndex: 'keyword',
          align: 'center',
        },
        {
          title: '类目图标',
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
          align: 'center',
        },
        {
          title: '跳转类型',
          dataIndex: 'jumpType',
          scopedSlots: { customRender: 'jumpType' },
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '布局',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
    if (!this.tenantFirmId) {
      this.getQi()
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
